module.exports = __webpack_public_path__ + "assets/img/gowuche1.e7159946.png";